module.exports = __webpack_public_path__ + "static/media/Oncology-Periodic Check In-1@3x.569ca5e2.png";